import type { CategorizationRule, KeywordMapping } from '../types';
import * as foodDining from './food-dining';
import * as shopping from './shopping';
import * as clothing from './clothing';
import * as transportation from './transportation';
import * as housing from './housing';
import * as homeServices from './home-services';
import * as billsInsurance from './bills-insurance';
import * as healthWellness from './health-wellness';
import * as entertainment from './entertainment';
import * as family from './family';
import * as financial from './financial';

// Combine all standard rules
// NOTE: Order matters! More specific patterns should come before generic ones.
// E.g., "gymnastics" (family) should be checked before "gym" (health-wellness)
export const STANDARD_RULES: CategorizationRule[] = [
  ...foodDining.RULES,
  ...shopping.RULES,
  ...clothing.RULES,
  ...transportation.RULES,
  ...housing.RULES,
  ...homeServices.RULES,
  ...billsInsurance.RULES,
  ...family.RULES,           // Before healthWellness (gymnastics vs gym)
  ...healthWellness.RULES,
  ...entertainment.RULES,
  ...financial.RULES,
];

// Combine all display name mappings
export const DISPLAY_NAME_MAPPINGS: KeywordMapping[] = [
  ...foodDining.DISPLAY_NAMES,
  ...shopping.DISPLAY_NAMES,
  ...clothing.DISPLAY_NAMES,
  ...transportation.DISPLAY_NAMES,
  ...housing.DISPLAY_NAMES,
  ...homeServices.DISPLAY_NAMES,
  ...billsInsurance.DISPLAY_NAMES,
  ...healthWellness.DISPLAY_NAMES,
  ...entertainment.DISPLAY_NAMES,
  ...family.DISPLAY_NAMES,
  ...financial.DISPLAY_NAMES,
];
